import axios from 'axios';
import routes from 'app/routes';

export default {
  saveAvatar: (enterpriseId, values, onSuccess) => {
    axios
      .post(routes.api.enterprises.saveAvatar(enterpriseId), values)
      .then((_resp) => {
        onSuccess();
      });
  },
};
